import { capitalize } from 'vue';

type PendingApprovalHandler = {
  get(target: Record<string, string>, p: string): Record<string, string> | string;
};

const pendingApprovalHandler: PendingApprovalHandler = {
  get(target, p) {
    if (!target[p]) {
      const obj: Record<string, string> = {};
      Object.keys(target).forEach((key) => (obj[key] = `${p}${capitalize(target[key])}`));
      return obj;
    }
    return Reflect.get(target, p);
  },
};

const GlobalEvents = Object.freeze({
  activeDealchanged: 'activeDealchanged',
  addAudienceLogicRule: 'addAudienceLogicRule',
  addBackgroundOperationsBatch: 'addBackgroundOperationsBatch',
  audienceLogicExpressionChanged: 'audienceLogicExpressionChanged',
  audienceLogicGeofenceGroupAdded: 'audienceLogicGeofenceGroupAdded',
  backgroundOperationBatchComplete: 'backgroundOperationBatchComplete',
  bulkCreationDialogActive: 'bulkCreationDialogActive',
  bulkCreationDialogInactive: 'bulkCreationDialogInactive',
  clearNotifications: 'clearNotifications',
  clearSomethingWentWrongStatus: 'clearSomethingWentWrongStatus',
  clearTooltips: 'clearTooltips',
  debug: 'debug',
  deleteAudienceRule: 'deleteAudienceRule',
  disableLoader: 'disableLoader',
  enableLoader: 'enableLoader',
  error: 'error',
  fetchUnreadAnnouncements: 'fetchUnreadAnnouncements',
  hideDealDetailsPane: 'hideDealDetailsPane',
  inlineEditError: 'inlineEditError',
  languageChanged: 'languageChanged',
  loaded: 'loaded',
  loading: 'loading',
  logout: 'logout',
  logoutDueToPasswordExpiry: 'logoutDueToPasswordExpiry',
  navbarToggled: 'navbarToggled',
  notify: 'notify',
  onMultiSelectSelectionChanged: 'onMultiSelectSelectionChanged',
  orgAccessDenied: 'orgAccessDenied',
  organizationChanged: 'organizationChanged',
  orgSubscriptionsChanged: 'orgSubscriptionsChanged',
  pendingApprovalsChanged: new Proxy(
    {
      default: 'pendingApprovalsChanged',
      lineItems: 'lineItemsPendingApprovalsChanged',
      creatives: 'creativesPendingApprovalsChanged',
      externalCreatives: 'externalCreativesPendingApprovalsChanged',
      fallbackCreatives: 'fallbackCreativesPendingApprovalsChanged',
    },
    pendingApprovalHandler,
  ),
  requestBlockedByClient: 'requestBlockedByClient',
  requestUriTooLong: 'requestUriTooLong',
  resetToken: 'resetToken',
  showCreativeWarningModal: 'showCreativeWarningModal',
  showDealDetailsPane: 'showDealDetailsPane',
  somethingWentWrong: 'somethingWentWrong',
  toggleSaveAndCancel: 'toggleSaveAndCancel',
  unauthorized: 'unauthorized',
  updateHeaderLogo: 'updateHeaderLogo',
  windowStatePopped: 'windowStatePopped',
});

export default GlobalEvents;
